import React, { useState } from 'react';
import { SidebarWrap } from './styled';
import { SidebarListItem } from './sidebar-list-item';
export function SidebarDirectoryStateless({ directory, onSelectDirectory, currentDirectory }) {
    const handleExpandNode = (id) => () => {
        if (expandedNode.includes(id)) {
            setExpandedNode([]);
        }
        else {
            setExpandedNode([id]);
        }
    };
    const handleSelectDirectory = (directory) => () => {
        onSelectDirectory(directory);
    };
    const [expandedNode, setExpandedNode] = useState([]);
    return (React.createElement(SidebarWrap, null, directory.map((item, index, list) => (React.createElement(SidebarListItem, { key: item.key, directory: item, handleExpand: handleExpandNode, isOpen: expandedNode.includes(item.key), selectDirectory: currentDirectory === null || currentDirectory === void 0 ? void 0 : currentDirectory.key, handleSelectDirectory: handleSelectDirectory, isLast: index === list.length - 1 })))));
}
